export const richTextSanitizeConfig = {
  ADD_ATTR: ["class", "target", "rel"],
};

const shouldKeepRelativeHref = (href: string): boolean =>
  href.startsWith("#") ||
  href.startsWith("/") ||
  href.startsWith("./") ||
  href.startsWith("../") ||
  href.startsWith("?");

const normalizeHref = (href: string): string => {
  const trimmedHref = href.trim();

  if (!trimmedHref || shouldKeepRelativeHref(trimmedHref)) {
    return trimmedHref;
  }

  if (trimmedHref.startsWith("//")) {
    return `https:${trimmedHref}`;
  }

  if (/^[a-z][a-z\d+\-.]*:/i.test(trimmedHref)) {
    return trimmedHref;
  }

  return `https://${trimmedHref}`;
};

export const normalizeRichTextLinkElement = (link: HTMLAnchorElement): void => {
  const href = link.getAttribute("href");

  if (!href) {
    return;
  }

  link.setAttribute("href", normalizeHref(href));
  link.setAttribute("target", "_blank");
  link.setAttribute("rel", "noopener noreferrer");
};

export const normalizeRichTextLinks = (html: string): string => {
  const template = document.createElement("template");
  template.innerHTML = html;

  template.content.querySelectorAll("a[href]").forEach((link) => {
    normalizeRichTextLinkElement(link as HTMLAnchorElement);
  });

  return template.innerHTML;
};
